import sliderDeluxe from './components/slider-deluxe';

function init() {

    sliderDeluxe.init();

}

export default {init: init};
